import { useContext, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-editor'
import Menu from '/components/templates/template-nav-menu'

import Editor from '/components/editor/index'

const TemplateEditor = () => {

  const navigate = useNavigate()
  const { templateId } = useParams()
  const { templates } = useContext(AppContext)

  const template = useMemo(() => {
    let t = templates.filter(t => t.id === templateId)[0]

    if (templates.length && !t) navigate("/templates")

    return t
  }, [templates, templateId])

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  return (
    <PageWrapper title="Template Editor" HelpText={HelpText} showWait heading={heading} menu={<Menu template={template} />}>
      <Editor />
    </PageWrapper>
  )
}

export default TemplateEditor